<template>
    <ul class="activities" v-if="activities.length" id="activitiesList">
        <li class="activities__item" v-for="activity in activities">
            <span class="badge badge-secondary">{{ activity.time }}</span>
            <p>
                <span v-if="activity.target.id !== userId">
                     <figure>
                        <img :src="activity.target.avatar"  />
                        <span :class="{'status':true,'f-online':activity.target.online}"></span>
                    </figure>
                </span>

                <span v-if="activity.user.id === userId">{{word.you}}</span>
                <span v-else>
                    <figure>
                        <img :src="activity.user.avatar"  />
                        <span :class="{'status':true,'f-online':activity.user.online}"></span>
                    </figure>
                    <a  :href="buildProfileUrl(activity.user.user_name)">{{ activity.user.name }}</a>

                </span>

               
                {{ buildEventName(activity.event) }}

                
           
                <span v-if="activity.target.id === userId">{{word.you}}</span>
                <span v-else>
                   
                    <a  :href="buildProfileUrl(activity.target.user_name)">{{ activity.target.name }}</a>
                </span>
            </p>
        </li>
    </ul>

    <p class="no-activities" v-else>
        {{text.no_activities_yet}}
    </p>
</template>

<script>
    export default {
        name: "user-activities",

        props: [
            'userId'
        ],

        data() {
            return {
                activities: [],
                word: window.word,
                text: window.text,
            }
        },

        methods: {
            fetchActivities() {
                axios.get('/dashboard/activities')
                    .then(response => this.activities = response.data.data)
                    .catch(error => console.log(error));
            },
            buildProfileUrl(username) {
                return `/${window.locale}/user/${username}`;
            },
            buildEventName(e) {
                if (e === 0) {
                    return ' ' + word.followed + ' ';
                }

                if (e === 1) {
                    return ' ' + this.word.unfollowed + ' ';
                }

                if (e === 2) {
                    return ' ' + this.word.visited_profile_of + ' ';
                }

                if (e === 3) {
                    return ' ' + this.word.send_a_chat_request_to + ' ';
                }

                if (e === 4) {
                    return ' ' + this.word.blocked + ' ';
                }

                if (e === 5) {
                    return ' ' + this.word.unblocked + ' ';
                }

                return ' ';
            }
        },

        mounted() {
            this.fetchActivities();
        }
    }
</script>

<style scoped>

    #activitiesList {
        margin-top: 20px;
        max-height: 450px;
        position: relative;
    }

    #activitiesList figure {
        display: inline-block;
        margin-bottom: 0;
        vertical-align: middle;
        width: 10%;
        position: relative;
    }
    #activitiesList figure img {
        border-radius: 100%;
    }

    .activities{
        margin-top: 10px;
    }

    .activities__item {
        display: flex;
        justify-items: left;
        flex-direction: column;
        align-items: flex-start !important;
        margin-bottom: 10px;
    }

    .activities__item:last-child {
        margin-bottom: 0;
    }

    .activities__item p, .activities__item p span {
        color: #333 !important;
    }

    .activities__item p a {
        color: #1289a5;
    }

    .no-activities {
        text-align: left;
        font-size: 13px;
        color: #666;
        padding: 45px 20px 5px 20px;
    }

    .badge-secondary {
        background-color: #9d9d9d !important;
        font-weight: normal !important;
        padding: 4px 5px !important;
    }
</style>
